module.exports = __webpack_public_path__ + "img/figuur4.e3fad78d.svg";